import { Text } from './base';

interface SubTitleProps {}

/** TODO: description for SubTitle component */
export class SubTitle extends Text<SubTitleProps, {}> {
    classes() {
        return super.classes({
            SubTitle: true
        });
    }
}
